import Router from "./booths-router";

import BoothsComponent from "./booths-component";


const Module = angular
    .module("app.booths", [])
    .component("booths", BoothsComponent)
    .config(Router);

export default Module;


// WEBPACK FOOTER //
// ./sources/components/booths/booths-module.js